import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step6 } from '../../../../shared/models/component-messages/mapaAT/step6';
import { TypeAutresInfosATTR } from '../models/TypeAutresInfosATTR';

@Component({
  selector: 'app-type-autres-infosATTR',
  templateUrl: './type-autres-infosATTR.component.html'
})
export class TypeAutresInfosATTRComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() autresInformations: TypeAutresInfosATTR;

  public step6 = new Step6();

  constructor() { }

  public ngOnInit() {
  }

  getUid() {
    return this.uid + '_SepSep_TypeAutresInfosATTR';
  }

  getUidPrime() {
    return this.getUid() + '_primeAttribuee_SepSep_TypeMontant';
  }
}
